import * as React from 'react'
import {
  styleguide,
  Column,
  Text,
  Row,
  Layout,
  Icon,
  DotDivider,
} from 'styleguide'
import { css } from 'react-emotion'
import * as Illustrations from '../../Illustrations'
import bg from './scoops.graph-w-text.svg'

export default function({ className }) {
  return (
    <Layout size="medium">
      <Row
        justify="space-between"
        align="center"
        break
        css={`
          z-index: 3;
        `}>
        <Row
          align="start"
          break
          css={`
            min-width: 50%;
          `}>
          <Icon
            icon="chart"
            css={`
              margin-right: 20px;
              margin-top: 3px;
              ${styleguide.mobile(css`
                margin-bottom: 20px;
              `)};
            `}
          />
          <Column>
            <Text subtitle bold serif secondary>
              Learn Over Time
            </Text>
            <DotDivider />
            <Text subtext pt>
              Validate the changes you make. See how your users react to a new
              feature or a new UI.
            </Text>
          </Column>
        </Row>
        <Row
          css={`
          margin-left: 40px;
            ${styleguide.mobile(
              css`
                margin-left: 0;
                order: 1;
                margin-top: 40px;
              `
            )}
            background-color: ${styleguide.colors.background};
            border-radius: ${styleguide.radii.outer};
            overflow: hidden;
            position: relative;
            z-index: 4;
            background-image: url(${bg});
            background-repeat: no-repeat;
            background-size: 101%;
            ${styleguide.shadows.button};
          `}>
          <div
            css={`
              padding-top: 76.9%;
              width: 100%;
            `}
          />
        </Row>
      </Row>
      <div
        css={`
          position: absolute;
          width: 100%;
          height: 100%;
          bottom: -200px;
          transform: scale3d(0.7, 0.7, 1);
          ${styleguide.desktop(
            css`
              top: 0;
              transform: none;
            `
          )};
        `}>
        <Illustrations.Stripes
          color="illustrationMarl"
          css={`
            position: absolute;
            right: -40px;
            top: 40px;
            width: 800px;
            height: 800px;
            z-index: 0;
          `}
        />
        <Illustrations.ChevronCircle
          color="primary"
          css={`
            position: absolute;
            right: 180px;
            bottom: -200px;
            width: 500px;
            height: 500px;
            z-index: 1;
          `}
        />
        <Illustrations.PokadotCircle
          color="illustrationLightBlue"
          light
          css={`
            position: absolute;
            right: 460px;
            bottom: 200px;
            width: 200px;
            height: 200px;
            z-index: 2;
          `}
        />
      </div>
    </Layout>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sections/LearnOverTime/index.js